import React, { Component } from 'react';
// import ReactDOM from 'react-dom'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _ from 'underscore';
// import browser from 'detect-browser';

import moment from 'moment';
import "moment-timezone";
import { detect } from 'detect-browser';

import ColoanaSt from './components/theme/ColoanaSt';
import ColoanaMid from './components/theme/ColoanaMid';
import ColoanaDr from './components/theme/ColoanaDr';
import PopUp from './components/theme/PopUp';
import WidgetPromotie from './components/containers/WidgetPromotie'
import WidgetPromotieLastResults from './components/containers/WidgetPromotieLastResults'
import TeaserText from './components/containers/TeaserText'

import { acAxiosRequest } from './components/actions/acAxiosRequest';
import { acConSizeChange } from './components/actions/acConSizeChange';
import { acSessionParams } from './components/actions/acSessionParams'
import { acPopVizibil } from './components/actions/acPopVizibil'

require("react-datepicker/dist/react-datepicker-cssmodules.css");
require("react-datepicker/dist/react-datepicker.css");
class App extends Component {

  constructor() {
    super();
    this.state = {
      errCodes: ['1000', '2000', '3000', '3100'],
      language: null,
      showHideWidget: false
    };
  }

  componentDidMount() {
    var url = window.location.href, idValue;
    if (url) {
      var url2 = new URL(url);
      var param_id = url2.searchParams.get("id");
      var param_value_id = url2.searchParams.get("value")
      idValue = param_id + "=" + param_value_id;
      if (!this.props.sessionParam) {
        this.props.acSessionParams(idValue)
      }
    }

    window.addEventListener('resize', this.updateWindowDimensions.bind(this));

    var tz = moment.tz.guess();

    var initdata = {
      ruta: this.props.appProps.ruta,
      request: 'initdata',
      reducer: 'DEFAULT_VAL',
      reducer2: 'MULTI_LANGUAGE',
      error: '1000',
      value: 'timezone=' + tz,
      newParam: this.props.sessionParam ? this.props.sessionParam : idValue
    }
    this.props.acAxiosRequest(initdata);

    var serverTime = {
      ruta: this.props.appProps.ruta,
      request: 'server_time',
      reducer: 'SERVER_TIME',
      error: '1100',
      newParam: this.props.sessionParam ? this.props.sessionParam : idValue
    }
    this.props.acAxiosRequest(serverTime);

    var axios = {
      ruta: this.props.appProps.ruta,
      request: 'get_lotteries',
      reducer: 'LOTERII',
      error: '2000',
      newParam: this.props.sessionParam ? this.props.sessionParam : idValue
    }
    this.props.acAxiosRequest(axios);
    var widgetBannerHeight = 0
    if (this.props.appProps.widgetPromo) {
      widgetBannerHeight = 172
    }
    var data = JSON.stringify({ "data": { "height": 1700 + widgetBannerHeight, "windowName": "gamePage" }, "type": "new_resize" });
    // console.log('FIRST IFRAME DIMENSIONS', data);
    window.parent.postMessage(data, "*")
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }
  updateWindowDimensions() {
    if (this.refContainer) {
      this.props.acConSizeChange({ appW: this.refContainer.offsetWidth })
    }
  }

  componentDidUpdate(prevProps, prevState) {

    if (this.state.language === null && this.props.defaultVal) {
      this.setState({
        language: this.props.defaultVal.language
      })
    }

    if (this.refContainer) {
      var dimensions = this.refContainer;
      if (_.isEqual(this.props.conSizeChange, prevProps.conSizeChange) === false) {
        this.props.acConSizeChange({ appW: dimensions.offsetWidth })

        if (dimensions.offsetWidth < 1000) {
          // var topWinnersHeight = (this.props.conSizeChange.topWiners && this.props.conSizeChange.topWiners > 109) ? this.props.conSizeChange.topWiners : 0
          var rightHeight = this.props.conSizeChange.colDr + this.props.conSizeChange.topWiners + this.props.conSizeChange.colSt //+ topWinnersHeight
          var middleHeight = this.props.conSizeChange.colMid + this.props.conSizeChange.colSt
        } else {
          rightHeight = _.max([this.props.conSizeChange.colSt, (this.props.conSizeChange.colDr)])
          middleHeight = this.props.conSizeChange.colMid
        }

        var height = _.max([dimensions.offsetHeight, rightHeight, middleHeight])
        var widgetBannerHeight = 0
        if (this.props.appProps.widgetPromo) {
          widgetBannerHeight = 172
        }
        // console.log('height', height, dimensions.offsetHeight, rightHeight, middleHeight);
        if (height > 300) {
          var data = JSON.stringify({ "data": { "height": height + 100 + widgetBannerHeight, "windowName": "gamePage" }, "type": "new_resize" });
          // console.log('NEW IFRAME DIMENSIONS', data, 'colst coldr', this.props.conSizeChange.colSt, this.props.conSizeChange.colDr, 'height before and banner', height, widgetBannerHeight);
          window.parent.postMessage(data, "*");
        }
      }
    }
  }

  redirect() {
    const browser = detect();
    if (browser) {
      // console.log('----------------->1  browser', browser.name, ' / ', 'sessionStorage', sessionStorage.getItem("mfbtls"), ' / ', 'url', window.location.href);
      if ((browser.name === 'safari') || (browser.name === 'ios')) {
        if (sessionStorage.getItem("mfbtls") !== 'active') {
          sessionStorage.setItem('mfbtls', 'active'); //redirect fix ios - only once
          window.top.location.href = this.props.appProps.ruta + "/safari";
        }
      }
    }

    if (this.props.error.conErr === true) {
      return <div className="conection-error">Conection Error ({this.props.error.val}) </div>
    }
    else if (!this.props.defaultVal) {
      return <div></div>
    }
  }

  checkErrCodes() {
    return (_.contains(this.state.errCodes, this.props.error.val))
  }
  clasament(e) {
    this.props.acPopVizibil({
      vizibil: true,
      position: { x: 'auto', y: 50 },
      info: { type: 'clasamentWidget' }
    })
    e.stopPropagation();
  }
  showHideWidget() {
    this.setState({
      showHideWidget: !this.state.showHideWidget
    })
  }
  render() {
    let conError = {
      en: 'Connection Error. Please, again try later.',
      ro: 'Eroare de conexiune. Vă rugăm să încercați mai târziu.',
      ru: 'Ошибка сети. Пожалуйста, попробуйте позднее.',
      uk: "Помилка з'єднання.Будь ласка, спробуйте пізніше",
      pt: 'Erro de conexão. O favor de tentar mais tarde.',
      gr: 'Σφάλμα σύνδεσης. Παρακαλώ δοκιμάστε και πάλι αργότερα.',
      de: 'Verbindungsfehler. Versuchen Sie bitte später.',
      tk: 'Internet näsazlygy, täzeden synanşyp görüň!',
      no: 'Tilkoblingsfeil. Prøv igjen senere.',
      da: 'Forbindelsesfejl. Prøv igen senere.',
      es: 'Error de Conexió. Por favor, intente más tarden.',
      fr: "Erreur de connexion. Veuillez réessayer plus tard.",
      ja: '接続エラー. 後でもう一度やり直してください',
      fi: 'Yhteysvirhe. Yritä uudelleen myöhemmin.'
    },
      language = this.state.language ? this.state.language : this.props.appProps.mainLang;
    let teaser = 'Cover_1588'
    if (this.props.conSizeChange && this.props.conSizeChange.appW) {
      let width = this.props.conSizeChange.appW
      if (width <= 440) {
        teaser = 'Cover_360'
      } else {
        teaser = 'Cover_1588'
      }
    }
    if ((this.props.defaultVal !== null) && (this.checkErrCodes() === false) && this.props.loterii) {
      let direction = this.state.showHideWidget ? 'up' : 'down'
      return (
        <div>
          <PopUp />
          <div ref={(f) => this.refContainer = f} >
            <div className="header-img"></div>
            <div className={"container container-bg " + this.props.defaultVal.language} >
              {/* {this.props.appProps.widgetPromo ? <div onClick={this.clasament.bind(this)} className="teaser"><img alt="" src={"img/promo/" + teaser + ".jpg"} /><TeaserText dimension='biggest' /></div> : null} */}
              {this.props.appProps.widgetPromo ? <a rel="noopener noreferrer" href="https://casino.netbet.ro/cursa-loteriilor-decembrie" target="_blank" className="teaser detaliiPromo"><div className="teaser"><img alt="" src={"img/promo/" + teaser + ".jpg"} /><TeaserText dimension='biggest' /></div></a> : null}
              {this.props.conSizeChange && this.props.conSizeChange.appW < 1000 && this.props.appProps.widgetPromo ? 
                <div className="btnWidget-con">
                  <div onClick={this.showHideWidget.bind(this)} className="btnWidgetMobile">{this.props?.multiLang?.cursaLoteriilor?.txt}</div>
                  <div onClick={this.showHideWidget.bind(this)} className={"arrow " + direction}></div>
                </div> 
              : null}
              {this.props.conSizeChange && this.props.conSizeChange.appW < 1000 && this.props.appProps.widgetPromo ?
                <div className={'mobile ' + this.state.showHideWidget}>
                  <WidgetPromotie />
                  {this.props?.widgetPromotie?.lastResults?.length >= 3 ? <WidgetPromotieLastResults /> : null}
                </div> 
              : null}              
              <ColoanaSt />
              <ColoanaMid />
              <ColoanaDr />
            </div>
          </div>
        </div>
      )
    } else {
      if (this.checkErrCodes() === true) {
        return <div className="con-error">{conError[language]}</div>
      } else {
        return (
          <div className="update">
            <div className="lds-ripple"><div></div><div></div></div>
          </div>
        )
      }
    }
  }
}

function mapStateToProps(state) {
  return {
    appProps: state.appProps,
    defaultVal: state.defaultVal,
    error: state.error,
    conSizeChange: state.conSizeChange,
    loterii: state.loterii,
    sessionParam: state.sessionParam,
    multiLang: state.multiLang,
    popVizibil: state.popVizibil,
    widgetPromotie: state.widgetPromotie
  }
}
function matchDispatchToProps(dispatch) {
  return bindActionCreators({
    acAxiosRequest: acAxiosRequest,
    acConSizeChange: acConSizeChange,
    acSessionParams: acSessionParams,
    acPopVizibil: acPopVizibil
  }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(App);
